import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { HelperService } from "../helperService";
@Injectable({
    providedIn: 'root'
})
export class APIAdvisorsService {
    
    ApiURL: string = "";
    
    constructor(private http: HttpClient, private helperService: HelperService) {
        this.ApiURL =environment.ServiceAdvisorURL + 'ServiceAdvisors'
    }

    public getAllAdvisors(): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
        return this.http.get<any[]>(this.ApiURL,requestOptions);
    }

    public getAdvisorById(advisorId): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
        return this.http.get<any>(this.ApiURL + "/" + advisorId,requestOptions);
    }
 
}

    
